export const PAYMENT_TAB = "Payment";
